<template>
<div>
  <div class="order-box bgTextColor" v-if="isShow">
    <div class="close" @click="close">×</div>
    <h2>预约咨询</h2>
    <h4>请输入下面的信息并提交信息</h4>
    <form>
      <ul>
        <li class="l4">
          <div class="name">姓名</div>
          <input type="text" v-model="form.username">
        </li>
        <li class="l4">
          <div class="name">电话</div>
          <input type="text" v-model="form.mobile">
        </li>
        <li class="l4">
          <div class="name">性别</div>
          <div class="label">
            <el-radio label="1" class="firstLabel label" v-model="form.sex">男</el-radio>
            <el-radio label="2" class="label" v-model="form.sex">女</el-radio>
          </div>
        </li>
        <li class="l5">
          <div class="name">城市/项目</div>
            <select v-model="provinceActive" @change="changeProvince($event)" style="margin-left:100px">
              <option v-for="(item, index) in provinceList" :key="index" :value="item.id">{{item.name}}</option>
            </select>
            <select class="selct2" v-model="storeActive" @change="changeStore($event)">
              <option v-for="(item, index) in storeList" :key="index" :value="item.id">{{item.store_name}}</option>
            </select>
        </li>
        <li class="l3">
          <div class="name">看房时间</div>
          <el-date-picker class="date" style="margin-left: 105px"
            v-model="form.open_home" type="date" placeholder="选择日期"
            format="YYYY-MM-DD"
            @change="dateChange"
          ></el-date-picker>
        </li>
        <li class="l1" style="position: relative;">
          <div class="name">验证码</div>
          <input type="text" v-model="form.code">
          <button :disabled="btnDisabled" class="sendCode bgColor" @click="sendCode">{{btnText}}</button>
        </li>
        <li class="l2">
          <div @click="submit" class="btn bgTextColor bgColor2">立即预约看房</div>
          <h5>我们收到您的预约信息将会尽快给您回电，请耐心等待。</h5>
        </li>
      </ul>
    </form>
  </div>
</div>
</template>

<script>
import { order, getProvinceList, getStoreListByProvinceId, sendSms } from '../api/api.js'
import { dateFormat, mendZero } from '../utils/common.js'
import { ElMessage } from 'element-plus'

export default {
  data () {
    return {
      btnText:'发送验证码',
      btnDisabled:false,
      isShow: false,
      provinceActive: -1,
      provinceList: [],
      storeActive: -1,
      storeList: [{ id: -1, store_name: '请选择' }],
      form: {
        username: '',
        mobile: '',
        sex: '',
        province_id: '',
        store_id: '',
        open_home: '',
        code: ''
      }
    }
  },
  mounted () {
    this.getProvinceList()
  },
  methods: {
    dateFormat,
    mendZero,
    async sendCode () {
      if (!this.form.mobile) {
        ElMessage.warning('请填入手机号')
        return
      }
      try {
        
        const res = await sendSms(this.form.mobile)
        this.btnDisabled = true;
        this.btnText = '发送成功...'
        var that = this
        setTimeout(function(){that.btnDisabled = false;that.btnText = '发送验证码'},60000)
      } catch (err) {
        ElMessage.error(err.message)
      }
    },
    close () {
      this.isShow = false
    },
    open () {
      this.isShow = true
    },
    dateChange (val) {
      this.form.open_home = this.dateFormat(val)
    },
    changeProvince (event) {
      this.provinceActive = event.target.value
      if (event.target.value === '-1') return
      this.form.province_id = event.target.value
      this.getStoreList(this.form.province_id)
    },
    changeStore (event) {
      this.storeActive = event.target.value
      this.form.store_id = event.target.value === -1 ? '' : event.target.value
    },
    async getStoreList (id) {
      try {
        const res = await getStoreListByProvinceId(id)
        this.storeList = res.data
        this.storeList.unshift({ id: -1, store_name: '请选择' })
        console.log('storeList',res.data)
      } catch (err) {
        ElMessage.error(err.message)
      }
    },
    async getProvinceList () {
      try {
        const res = await getProvinceList()
        this.provinceList = res.data
        this.provinceList.unshift({ id: -1, name: '请选择' })
      } catch (err) {
        ElMessage.error(err.message)
      }
    },
    async submit () {
      console.log(this.form)
      try {
        const res = await order(this.form)
        ElMessage.success('提交成功～')
        this.isShow = false
        this.form = {}
      } catch (err) {
        ElMessage.error(err.message)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.order-box {
  width: 650px;
  position: fixed;
  left: 50%;
  top: 50%;
  background: #eee;
  margin-left: -355px;
  padding: 23px 60px 0px 60px;
  overflow: hidden;
  z-index: 999;
  border-radius: 8px;
  transform: translate(0, -50%);
  .close {
    position: absolute;
    right: 20px;
    top: 20px;
    font-size: 50px;
    line-height: 1;
    font-weight: bold;
    cursor: pointer;
  }
  h2 {
    text-align: center;
    font-size: 32px;
    line-height: 52px;
  }
  h4 {
    text-align: center;
    margin-top: 9px;
    font-size: 16px;
    line-height: 26px;
    letter-spacing: 1px;
  }
  form {
    ul {
      margin-top: 17px auto;
      padding: 0;
      li {
        margin-top: 14px;
        background: #fff;
        position: relative;
        overflow: hidden;
        .sendCode {
          position: absolute;
          right: 20px;
          top: 5px;
          color: #fff;
          padding: 5px 10px;
          display: inline-block;
          border-radius: 30px;
          cursor: pointer;
        }
        .name {
          position: absolute;
          left: 20px;
          top: 0;
          font-size: 16px;
          color: #666666;
          line-height: 45px;
          letter-spacing: 1px;
        }
        input {
          outline: none;
          border: none;
          width: 100%;
          height: 42px;
          background: none;
          padding: 15px 20px 15px 120px;
          line-height: 22px;
          font-size: 16px;
          color: #333;
        }
        .firstLabel {
          margin-left: 120px;
        }
        .label {
          height: 52px;
          line-height: 52px;
        }
        select {
          display: block;
          padding-left: 2%;
          width: 40%;
          float: left;
          font-size: 16px;
          letter-spacing: 1px;
          height: 52px;
          line-height: 50px;
          border: 0;
          border-bottom: solid 2px rgba(255,255,255,0.3);
          outline: 0;
          border-radius: 0;
        }
      }
      .l1 {
        padding-right: 140px;
      }
      .l2 {
        background: none;
        margin-top: 30px;
        padding: 0;
        div {
          width: 100%;
          font-size: 18px;
          line-height: 57px;
          height: 57px;
          padding: 0;
          letter-spacing: 1px;
          cursor: pointer;
          color: #fff;
        }
        h5 {
          text-align: center;
          margin-top: 22px;
          line-height: 26px;
          color: #666;
          font-size: 16px;
          letter-spacing: 1px;
        }
      }
      .l3 {
        .date {
          height: 52px;
          line-height: 52px;
          border: none;
        }
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .order-box {
    width: 80%;
    left: 10%;
    margin-left: 0;
    padding: 10px 12px 0 12px;
    .close {
      right: 10px;
      top: 10px;
      font-size: 30px;
    }
    h2 {
      font-size: 25px !important;
      line-height: 40px !important;
    }
    h4 {
      margin-top: 5px !important;
      font-size: 14px !important;
      line-height: 20px !important;
      letter-spacing: 0px !important;
    }
    ul {
      margin-top: 10px !important;
      padding-left: 0 !important;
      li {
        margin-top: 8px !important;
        .name {
          left: 10px !important;
          font-size: 14px;
          line-height: 42px !important;
          height: 45px !important;
        }
        input {
          height: 42px !important;
          padding: 10px 0 !important;
          font-size: 14px;
        }
        .firstLabel {
          margin-left: 38px !important;
        }
        .label {
          line-height: 42px !important;
          height: 42px !important;
        }
        .sendCode {
          padding: 4px 10px !important;
          right: 7px !important;
        }
      }
      .l2 {
        margin-top: 18px !important;
        .btn {
          font-size: 17px;
          height: 46px !important;
          line-height: 46px !important;
        }
        h5 {
          margin-top: 10px !important;
          font-size: 13px !important;
          line-height: 20px !important;
        }
      }
      .l3 {
        padding: 0 15px 0 58px !important;
        .date {
          margin-left: 0 !important;
        }
      }
      .l1 {
        padding: 0 15px 0 58px !important;
      }
      .l4 {
        padding: 0 15px 0 58px !important;
      }
      .l5 {
        .name {
          display: block !important;
        }
        .selct2 {
          position: relative;
          left: 36%;
        }
      }
    }
  }
}

</style>
